<template>
  <div>
    <ValuesChart
      v-if="screened && (values.a.length > 0 || screens.a.length > 0)"
      v-bind:chartData="chartData"
      v-bind:options="chartOptions"
      v-bind:width="150"
      v-bind:height="50"
    />
  </div>
</template>

<script>
  import chroma from 'chroma-js';

  import ValuesChart from '@frontend/dash3/js/components/fundscreener/ValuesChart.js';

  import {preciseRound} from '@frontend/shared/Util.js';

  export default {
    data() {
      return {
        // TODO: Unify between working portfolio main chart and this mini chart
      }
    },
    components: {
      ValuesChart,
    },
    props: {
      ticker: Object,
      screened: Object,
      screens: Object,
      values: Object,
      chartValueRange: {
        type: Array,
        default() {
          return [0, 10]
        }
      }
    },
    methods: {
      colorScale: function() {
        return chroma.scale(['red', 'white', 'lightgreen']).domain(this.chartValueRange);
      },

    },
    computed: {
      chartOptions: function() {
        return {
          plugins: {
            legend: {
              display: false,
            },
          },
          scales: {
            y: {
              grid: {
                display: false,
                drawBorder: false,
                color: 'hotpink'
              },
              display: false,
              min: 0,
              max: this.screens.a.length > 0 ? 100 : 10,
              stepSize: 1
            },
            x: {
              display: false,
            }
          }
        }
      },
      chartData: function() {
        let overall = this.screened.composite;
        if (this.screens.a.length > 0) {
          overall = overall * 100;
        }
        let color = this.colorScale()(overall);
        let data = {
          labels: ['Overall Alignment'],
          datasets: [
            {
              backgroundColor: [color.hex()],
              hoverBackgroundColor: [color.hex()],
              borderColor: [chroma(color).darken().hex()],
              borderWidth: 1,
              data: [preciseRound(overall, 1)]
            }
          ]
        }
        this.values.a.forEach((itm) => {
          data.labels.push(itm.name);
          let score = this.screened[`composite_values_${itm.id}`];
          let color = this.colorScale()(score).hex();
          data.datasets[0].backgroundColor.push(color);
          data.datasets[0].hoverBackgroundColor.push(color);
          data.datasets[0].borderColor.push(chroma(color).darken().hex());
          if (score === null) {
            data.datasets[0].data.push(Number.NaN);
          }
          else {
            data.datasets[0].data.push(preciseRound(score, 1));
          }
        });

        this.screens.a.filter((itm) => { return itm.userPercentile > 0 }).forEach((itm) => {
          data.labels.push(itm.name);
          let score = this.screened[`metric_${itm.id}_percentile`] * 100;
          let color = this.colorScale()(score).hex();
          data.datasets[0].backgroundColor.push(color);
          data.datasets[0].hoverBackgroundColor.push(color);
          data.datasets[0].borderColor.push(chroma(color).darken().hex());
          if (score === null) {
            data.datasets[0].data.push(Number.NaN);
          }
          else {
            data.datasets[0].data.push(preciseRound(score, 1));
          }
        });

        return data;
      },
    },
    created: function() {
    }
  }
</script>

<style lang="scss">
</style>
